$(function () {


	var flag = '';

	$(window).on('load resize', function () {
		var w = $(window).innerWidth();

		// sp幅
		if (w <= 480 && flag != 'sp') {
			flag = 'sp';
			// sp時の処理をここに書く
			console.log('spの処理');
			$(".business__detail:nth-of-type(1)").removeClass("show");
			$(".is-pcActive").removeClass("active");

			// pc幅
		} else if (w > 480 && flag != 'pc') {
			flag = 'pc';
			// pc時の処理をここに書く
			console.log('pcの処理');
			$(".business__detail:nth-of-type(1)").addClass("show");
			$(".is-pcActive").addClass("active");
		}
	});





	$(".business__listTabItem").on("click", function () {
		const showClass = $(this).children(".business__listTabItemText").hasClass("active");
		const group = $(this).parents(".business");



		if (showClass) {
			$(this).children(".business__listTabItemText").removeClass("active");
			const index = $(this).index();
			group.find(".business__detail").eq(index).removeClass("show");
		}
		else {
			group.find(".active").removeClass("active");
			$(this).children(".business__listTabItemText").addClass("active");
			group.find(".show").removeClass("show");
			const index = $(this).index();
			if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
				$(".business__detail").eq(index).appendTo(this);
			}
			group.find(".business__detail").eq(index).addClass("show");
		}



	})
})
